<template>
  <div class="timeline-body">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'timeline-body',
  props: {}
};
</script>

<style>
  .timeline-body .btn-group {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .timeline-body p,
  .timeline-body h4,
  .timeline-body ul {
    font-weight: 300;
    margin-bottom: 5px;
  }

  .timeline-body p + p {
    margin-top: 0px;
  }

  .timeline-body {
    margin-bottom: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/TimelineBody.vue